import {
  DetalleTransporte,
  EntradaTransporte,
} from "../../../services/transporteServicios";
import { ListGroupItem } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconContainer from "../../organisms/IconContainer";
import SuccessIconContainer from "../../organisms/SuccessIconContainer";
import DangerIconContainer from "../../organisms/DangerIconContainer";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import { ModificacionesDetalle } from "./Modificaciones";

function EntradaItem({
  entrada,
  onDetalleClick,
  onChequearEntrada,
  modificacionesEntrada,
  onSubirOrden,
  esPrimero,
  anterior,
  siguiente,
  onBajarOrden,
  esUltimo,
}: {
  entrada: EntradaTransporte;
  onDetalleClick: (detalle: DetalleTransporte) => void;
  onChequearEntrada: (
    entrada: EntradaTransporte,
    transportado: boolean
  ) => void;
  onSubirOrden: (
    entrada: EntradaTransporte,
    anterior: EntradaTransporte
  ) => void;
  onBajarOrden: (
    entrada: EntradaTransporte,
    siguiente: EntradaTransporte
  ) => void;
  modificacionesEntrada: ModificacionesDetalle | undefined;
  esPrimero: boolean;
  esUltimo: boolean;
  anterior: EntradaTransporte | undefined;
  siguiente: EntradaTransporte | undefined;
}) {
  const onClickViewDetalle = () => {
    onDetalleClick(entrada);
  };

  const transportado =
    modificacionesEntrada && modificacionesEntrada.transportado !== undefined
      ? modificacionesEntrada.transportado
      : entrada.transportado;

  return (
    <ListGroupItem
      as="li"
      className={`d-flex mt-2 p-1 border rounded ${
        transportado ? "border-success" : ""
      }`}
    >
      <div className="ps-2 row" style={{ paddingRight: 0 }}>
        <div className="row" style={{ paddingRight: 0 }}>
          <div className="col-7">
            <strong>{entrada.mascota.nombre}</strong>
          </div>
          <div className="col-5">
            <div className="row justify-content-end" style={{ paddingRight: 0 }}>
              
                {!esPrimero && (
                  <div className="col-3">
                  <IconContainer
                    onClick={() => {
                      onSubirOrden(entrada, anterior!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowUpwardIcon />
                  </IconContainer>
                  </div>
                )}
              

              {!esUltimo && (
                <div className="col-3">
                  <IconContainer
                    onClick={() => {
                      onBajarOrden(entrada, siguiente!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowDownwardIcon />
                  </IconContainer>
                </div>
              )}
              <div className="col-3">
                <IconContainer
                  onClick={onClickViewDetalle}
                  style={{ cursor: "pointer" }}
                >
                  <VisibilityIcon />
                </IconContainer>
              </div>
              {transportado && (
                <div className="col-3">
                  <DangerIconContainer
                    onClick={() => {
                      onChequearEntrada(entrada, false);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ClearIcon />
                  </DangerIconContainer>
                </div>
              )}
              {!transportado && (
                <div className="col-3">
                  <SuccessIconContainer
                    onClick={() => {
                      onChequearEntrada(entrada, true);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <CheckIcon />
                  </SuccessIconContainer>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <small>{entrada.hora}</small>
        </div>
        <div className="row">
          <small>
            {entrada.direccion} - {entrada.sector}
          </small>
        </div>
      </div>
    </ListGroupItem>
  );
}

export default EntradaItem;
